/**
 * number()
 * @returns {string}
 */
const number = () => {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
};

/**
 * character()
 * @param length
 * @returns {string}
 */
const character = length => {
  let text = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
};

/**
 * Guid
 */
export class Guid {

  static NEW() {
    return (number() + number() + '-' + number() + '-' + number() + '-' + number() + '-' + number() + number() + number());
  }

  static CHAR(length = 8) {
    return (character(length));
  }
}
